import Breadcrumbs from "../Bc-Breadcrumb/Bc-breadcrumb";

const BcTitleHeader = ({ title }: any) => {
  return (
    <div className="bc-page-header bc-page-header-white">
      <div className="bc-container bc-page-header-content">
        <div className="bc-page-header-content-left bc-col-md-12 bc-col-sm-12 bc-col-xs-12">
          <Breadcrumbs />
          <div className="bc-page-header-content-left-title">
            <h6>{title}</h6>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BcTitleHeader;
